import { render, staticRenderFns } from "./PickTicket.vue?vue&type=template&id=51ce2d6a&scoped=true&"
import script from "./PickTicket.vue?vue&type=script&lang=js&"
export * from "./PickTicket.vue?vue&type=script&lang=js&"
import style0 from "./PickTicket.vue?vue&type=style&index=0&id=51ce2d6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ce2d6a",
  null
  
)

export default component.exports